import React, { useState } from 'react';

import { GameHtmlZone, GameZone } from './GameScreen.style';
import {
  GameScreenConfiguration,
} from '../../common-types/ScreensConfigurations.type';
import { WheelPlugin } from '../game-plugins/WheelPlugin';
import { OneArmedBanditPlugin } from '../game-plugins/OneArmedBanditPlugin';
import { ScratchPlugin } from '../game-plugins/ScratchPlugin';
import { Background } from '../common-components/Background';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

const MILLISECONDS_BEFORE_LAUNCHING_GAME_AFTER_LOAD = 500;

interface Props {
  config: GameScreenConfiguration;
  onGameBegin?: () => void;
  onGameDone?: () => void;
  addEditableBlock?: (block: BlockInfoType) => void;
  removeEditableBlock?: (configPath: string) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  hasWon?: boolean | null;
}

export const GameScreen: React.FunctionComponent<Props> = ({
  addEditableBlock,
  removeEditableBlock,
  config,
  onGameBegin,
  onGameDone,
  isEdition,
  onBlockEdit,
  hasWon,
}: Props) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const onPluginLoaded = (): void => {
    if (isEdition === true) {
      return;
    }
    setTimeout(() => {
      setIsPlaying(true);
      if (onGameBegin) {
        onGameBegin();
      }
    }, MILLISECONDS_BEFORE_LAUNCHING_GAME_AFTER_LOAD);
  };

  const handleEndOfPlugin = (): void => {
    if (onGameDone) {
      onGameDone();
    }
  };

  const commonPluginProps = {
    hasWon:
      hasWon === undefined
        ? null
        : hasWon,
    onPluginDone: handleEndOfPlugin,
    addEditableBlock,
    removeEditableBlock,
    onBlockEdit,
    isPlaying,
    isEdition: isEdition === true,
    onLoad: onPluginLoaded,
  };

  return (
    <Background
      displayName="Background"
      sizeInfo={{ height: 1200, width: 1200 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig="screens.game.background"
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <GameHtmlZone
        displayName="HTML Zone"
        addEditableBlock={addEditableBlock}
        dataTemplateConfig="screens.game.mainTextBox"
        html={config.mainTextBox.html}
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
      <GameZone>
        {config.plugin.type === 'wheel' && config.plugin.plugins.wheel !== undefined &&
          <WheelPlugin
            config={config.plugin.plugins.wheel}
            {...commonPluginProps}
          />
        }
        {config.plugin.type === 'scratch' && config.plugin.plugins.scratch !== undefined &&
          <ScratchPlugin
            config={config.plugin.plugins.scratch}
            {...commonPluginProps}
          />
        }
        {config.plugin.type === 'armedBandit' && config.plugin.plugins.armedBandit !== undefined &&
          <OneArmedBanditPlugin
            config={config.plugin.plugins.armedBandit}
            {...commonPluginProps}
          />
        }
      </GameZone>
    </Background>
  );
};
